import React from "react";
import cn from "classnames";
import styles from "./Switcher.module.scss";
import { useAsyncCallback } from "react-async-hook";
import { twMerge } from "tailwind-merge";
import { HeadlessUi } from "../headlessUi";
const Switcher = ({ className, containerClassName, circleClassName, value, onClick, disabled, dataCySuffix, color = "main", }) => {
    const callback = useAsyncCallback(onClick);
    const _loading = callback.loading;
    const isEnabled = value && !_loading;
    const dataCy = (name) => {
        return dataCySuffix ? `${name}-${dataCySuffix}` : name;
    };
    const dataCyProps = {
        root: dataCy("ukt-switcher"),
        circle: dataCy("ukt-switcher-circle"),
    };
    const colors = {
        main: "#0BA9DA",
        green: "#83A336",
    };
    const dynamicStyles = {
        "--selected-color": colors[color],
        borderColor: isEnabled ? colors[color] : "#878787",
    };
    return (React.createElement("div", { className: twMerge("h-[24px] w-[42px] flex-shrink-0", className), "data-cy": dataCyProps.root },
        React.createElement(HeadlessUi.Switch, { style: dynamicStyles, className: twMerge("h-full w-full rounded-[13px] border-[2px] border-solid border-icon-grey-color", "relative flex cursor-pointer items-center", "left-0 box-border transition-[all_0.25s_ease]", cn({
                "cursor-not-allowed opacity-[0.6]": disabled,
                "pointer-events-none": _loading,
            }), containerClassName), checked: isEnabled, onChange: () => !disabled && callback.execute(!value), disabled: disabled },
            React.createElement("div", { "data-cy": dataCyProps.circle, className: cn(styles.circle, {
                    [styles.loading]: _loading,
                    [styles.on]: isEnabled,
                }, circleClassName) }))));
};
export default Switcher;
//# sourceMappingURL=Switcher.js.map